import mitt, { Emitter } from 'mitt';

type EventHandler = (payload?: any) => void;
type Events = Record<string, unknown>;

const emitter: Emitter<Events> = mitt<Events>();

const eventBus = {
    $on(event: string | string[], handler: EventHandler): void {
        if (Array.isArray(event)) {
            for (const eventName of event) {
                emitter.on(eventName, handler);
            }
            return;
        }

        emitter.on(event, handler);
    },

    $off(event?: string | string[], handler?: EventHandler): void {
        if (event === undefined) {
            emitter.all.clear();
            return;
        }

        const events = Array.isArray(event) ? event : [event];

        if (handler === undefined) {
            for (const eventName of events) {
                emitter.all.delete(eventName);
            }
            return;
        }

        for (const eventName of events) {
            emitter.off(eventName, handler);
        }
    },

    $emit(event: string, payload?: unknown): void {
        emitter.emit(event, payload);
    },

    on: emitter.on.bind(emitter),
    off: emitter.off.bind(emitter),
    emit: emitter.emit.bind(emitter),
};

export default eventBus;
